import {Model} from '@vuex-orm/core'
import {LigneRetro} from '@/models/ApiModels/LigneRetro'
import {Ligne} from '@/models/ApiModels/Ligne'

export class Retrocession extends Model {
  static entity = 'Retrocession'

  static fields () {
    return {
      id: this.number(null),
      quantiteMouvement: this.attr(''),
      aRetroceder: this.boolean(true),
      articleAbandonne: this.boolean(false),
      articleRendu: this.boolean(false),
      paiementDate: this.string(''),
      montantRetrocession: this.string(''),
      article_id: this.number(null),
      ligne: this.hasOne(LigneRetro, 'retrocession_id'),
      ligneEntete: this.belongsTo(Ligne, 'ligne_id'),
      ligne_id: this.number(null)
    }
  }

  static fetchRetrocessions($depotVente, $deposant){
    return this.api().get('/deposant/' + $depotVente + '/' + $deposant + '/retrocessions');
  }
}
